import React from 'react';
import { colors, radii, shadows, fonts, fontSize } from '../theme/tokens';

export interface CardProps {
  children: React.ReactNode;
  dense?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

/* §4 Card — white, radius 12, pad 20 (dense 16), soft shadow. */
export const Card: React.FC<CardProps> = ({ children, dense, style, className }) => (
  <div
    className={className}
    style={{
      background: '#fff',
      borderRadius: radii.card,
      padding: dense ? spacingDense : 20,
      boxShadow: shadows.card,
      ...style,
    }}
  >
    {children}
  </div>
);
const spacingDense = 16;

/* Section title inside a card: 14px weight 600 brand green. */
export const CardTitle: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({
  children,
  style,
}) => (
  <div
    style={{
      fontSize: fontSize.cardHeading,
      fontWeight: 600,
      color: colors.brandGreen,
      fontFamily: fonts.body,
      ...style,
    }}
  >
    {children}
  </div>
);

export default Card;
